import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link } from '@mui/docs/Link';
import { useTranslate } from '@mui/docs/i18n';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NativeLink = styled('a')(function (_ref) {
  var theme = _ref.theme;
  return _extends({
    boxSizing: 'border-box',
    // TODO have CssBaseline in the Next.js layout
    width: '100%',
    height: 45,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderLeft: '1px solid',
    borderRight: '1px solid',
    borderBottom: 0,
    borderColor: (theme.vars || theme).palette.divider,
    transition: theme.transitions.create(['background-color']),
    '&:first-of-type': {
      borderTop: "1px solid ".concat((theme.vars || theme).palette.divider),
      borderRadius: '12px 12px 0 0'
    },
    '&:hover': {
      backgroundColor: (theme.vars || theme).palette.grey[50]
    },
    '&:focus-visible': {
      outline: "3px solid ".concat(alpha(theme.palette.primary[500], 0.5)),
      outlineOffset: '-3px'
    },
    '& img': {
      display: 'inline-block'
    }
  }, theme.applyDarkStyles({
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary[900], 0.1)
    }
  }));
});
export default function DiamondSponsors() {
  var t = useTranslate();
  return /*#__PURE__*/_jsxs(Stack, {
    direction: "column",
    sx: {
      mt: 2,
      mx: 0.5
    },
    children: [/*#__PURE__*/_jsx(NativeLink, {
      "data-ga-event-category": "sponsor",
      "data-ga-event-action": "docs-premium",
      "data-ga-event-label": "doit.com",
      href: "https://www.doit.com/?utm_source=mui.com&utm_medium=referral",
      rel: "noopener sponsored",
      target: "_blank",
      children: /*#__PURE__*/_jsx(Box, {
        component: "img",
        src: "/static/sponsors/doit-light.svg",
        alt: "doit",
        title: "Management Platform for Google Cloud and AWS",
        loading: "lazy",
        sx: [{
          height: '29px',
          width: '70px'
        }, function (theme) {
          return theme.applyDarkStyles({
            content: "url(/static/sponsors/doit-dark.svg)"
          });
        }]
      })
    }), /*#__PURE__*/_jsx(Link, {
      href: "/material-ui/discover-more/backers/#diamond-sponsors",
      sx: function sx(theme) {
        return _extends({
          height: 45,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px dashed',
          borderColor: (theme.vars || theme).palette.grey[300],
          borderRadius: '0 0 12px 12px',
          backgroundColor: alpha(theme.palette.primary[50], 0.4),
          transition: theme.transitions.create(['color', 'background-color']),
          '&:hover': {
            backgroundColor: (theme.vars || theme).palette.primary[50],
            borderColor: (theme.vars || theme).palette.primary[200]
          },
          '&:focus-visible': {
            outlineOffset: '-3px'
          }
        }, theme.applyDarkStyles({
          backgroundColor: alpha(theme.palette.primaryDark[700], 0.3),
          borderColor: alpha(theme.palette.primaryDark[600], 0.5),
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary[700], 0.1),
            borderColor: alpha(theme.palette.primary[600], 0.4)
          }
        }));
      },
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "caption",
        sx: {
          fontWeight: 'medium'
        },
        children: t('becomeADiamondSponsor')
      })
    })]
  });
}